<template>
  <div class="container">
    <h1>Statistics by {{ (this.version ? (this.version == "old" ? "Month" : this.version) : "Month") }}</h1>
    <div class="row margin-bottom-2">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged"/>
      </div>
    </div>
    <sdx-loading-spinner id="spinner-charts" class="margin-1" size="large"
                         sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div id="charts" v-if="showStatistics">
      <div id="chartsCountSms" class="sms-statistic-chart">
        <div id="smsStatisticChart" v-bind:key="chart_data_wrapper_count_sms">
          <canvas :id="`canvas_chart`"/>
        </div>
      </div>
      <div id="chartsAmountChf" class="sms-statistic-chart" v-if="showStatisticsChf && !isVersionHourly()">
        <div v-bind:key="chart_data_wrapper_amount_chf">
          <canvas :id="`canvas_chart_chf`"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statisticService from '@/modules/statistics/service.js';
import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);
import _ from 'lodash';
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import userService from "@/services/user.service";
import loadingSpinnerService from "@/services/loading-spinner.service";
import {logger} from "@/services/logger.service";
import {showAlert} from "@/services/notification.service";
import numeral from "numeral";

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const statusNames = ["FAILURE", "PROCESSING", "DELIVERED", "CONFIRMED", "NO_INFO", "BLOCKED"]
export default {
  props: [],
  components: {
    DevAppDropDownComponent,
  },
  mounted() {
    switch (this.$route.query.version) {
      case "months":
        this.version = "months";
        break;
      case "days":
        this.version = "days";
        break;
      case "hours":
        this.version = "hours";
        break;
    }
    this.months = (this.$route.query.months ? numeral(this.$route.query.months).format("0") : 6);
    this.days = (this.$route.query.days ? numeral(this.$route.query.days).format("0") : 62);
    this.hours = (this.$route.query.hours ? numeral(this.$route.query.hours).format("0") : 72);
    this.loadStatistics();
  },
  data: function () {
    return {
      webId: undefined,
      statistic: [],
      chart_count_sms: undefined,
      chart_amount_chf: undefined,
      chart_objects_count_sms: [],
      chart_objects_amount_chf: [],
      chart_data_wrapper_count_sms: [],
      chart_data_wrapper_amount_chf: [],
      isLoading: false,
      showStatistics: false,
      showStatisticsChf: false,
      version: "Month",
      months: undefined,
      days: undefined,
      hours: undefined
    }
  },
  methods: {
    devAppChanged: async function (webId) {
      this.webId = webId;
      await this.loadStatistics();
    },
    loadStatistics: async function () {
      loadingSpinnerService.show("charts")
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        logger.debug("...")
        this.showStatistics = false
      } else {
        try {
          this.showStatistics = true;
          this.isLoading = true;
          let response;
          switch (this.version) {
            case "months":
              response = await statisticService.getStatisticsByMonthsNew(this.webId, this.months, userService.getViewUserEmail());
              break;
            case "days":
              response = await statisticService.getStatisticsByDaysNew(this.webId, this.days, userService.getViewUserEmail());
              break;
            case "hours":
              response = await statisticService.getStatisticsByHoursNew(this.webId, this.hours, userService.getViewUserEmail());
              break;
            case "Month"://old version
              response = await statisticService.getStatistics(this.webId, this.months, userService.getViewUserEmail());
          }
          this.statistic = response.data;
          await this.calculateChartData();
          await this.reloadCharts()
          this.isLoading = false;
        } catch (error) {
          showAlert(error.message)
        }
      }
      loadingSpinnerService.hide("charts")
    },
    reloadCharts: async function () {
      await this.chart_objects_count_sms.pop()
      if (!this.chart_objects_count_sms[0]) {
        var domEl = document.getElementById("canvas_chart")
        if (this.chart_count_sms !== undefined) {
          this.chart_count_sms.destroy()
        }
        this.chart_count_sms = new Chart(domEl, {
          type: 'bar',
          data: this.chart_data_wrapper_count_sms.chart_data,
          options: this.chart_data_wrapper_count_sms.options,
        })
        this.chart_objects_count_sms.push(this.chart_count_sms)
      }

      if (this.showStatisticsChf) {
        await this.chart_objects_amount_chf.pop()
        if (!this.chart_objects_amount_chf[0]) {
          var domElChf = document.getElementById("canvas_chart_chf")
          if (this.chart_amount_chf !== undefined) {
            this.chart_amount_chf.destroy()
          }
          this.chart_amount_chf = new Chart(domElChf, {
            type: 'bar',
            data: this.chart_data_wrapper_amount_chf.chart_data,
            options: this.chart_data_wrapper_amount_chf.options,
          })
          this.chart_objects_amount_chf.push(this.chart_amount_chf)
        }
      }
    },
    getMonthDetails(details) {
      var parts = details.split('-')
      var month = monthNames[Number(parts[1]) - 1]
      var year = parts[0].substring(2, 4)
      return month + "'" + year
    },
    isVersionHourly() {
      return this.version == "hours"
    },
    calculateChartData() {
      let vv = this

      this.showStatisticsChf = this.statistic.attributes !== undefined && (
          Number(this.statistic.attributes.swisscomPrice[1]) > 0 ||
          Number(this.statistic.attributes.domesticPrice[1]) > 0 ||
          Number(this.statistic.attributes.internationalPrice[1]) > 0 ||
          Number(_.get(this.statistic.attributes, 'blockedPrice[1]', 0)) > 0)

      this.chart_data_wrapper_count_sms = {
        "productName": this.statistic.productName,
        "devAppName": this.statistic.displayName,
        "status": this.statistic.status,
        "is_shown": true,
        "options": vv.getChartOptions(false),
        "chart_data": {
          "labels": _.transform(this.statistic.months, function (lbl, month) {
            lbl.push(month.date)/*vv.getMonthDetails(month.date))*/
          }, []),
          "datasets": vv.getChartDatasets(this.statistic, false)
        }
      }


      this.chart_data_wrapper_amount_chf = {
        "productName": this.statistic.productName,
        "devAppName": this.statistic.displayName,
        "status": this.statistic.status,
        "is_shown": true,
        "options": vv.getChartOptions(true),
        "chart_data": {
          "labels": _.transform(this.statistic.months, function (lbl, month) {
            lbl.push(month.date)/*vv.getMonthDetails(month.date))*/
          }, []),
          "datasets": vv.getChartDatasets(this.statistic, true)
        }
      }
    },


    getChartDatasets(statistic, chf_or_sms) {
      let datasets = []
      if (!chf_or_sms) {
        if (this.isVersionHourly()) {
          for (const statusIndex in statusNames) {
            let statusName=statusNames[statusIndex]
            datasets.push(this.getDataSetByDestType('SMS Swisscom (' + statusName + ')', 'Swisscom_' + statusName, statistic.months, this.getColorByState(statusName), 'sms', 'usage')) // #6BF3F0
            datasets.push(this.getDataSetByDestType('SMS Domestic (' + statusName + ')', 'Domestic_' + statusName, statistic.months, this.getColorByState(statusName), 'sms', 'usage')) // #59BFDD
            datasets.push(this.getDataSetByDestType('SMS International (' + statusName + ')', 'International_' + statusName, statistic.months, this.getColorByState(statusName), 'sms', 'usage')) // #BEDD77
          }
        } else {
          datasets.push(this.getDataSetByDestType('SMS Swisscom', 'Swisscom', statistic.months, '#1781E3', 'sms', 'usage')) // #6BF3F0
          datasets.push(this.getDataSetByDestType('SMS Domestic', 'Domestic', statistic.months, '#86BFF2', 'sms', 'usage')) // #59BFDD
          datasets.push(this.getDataSetByDestType('SMS International', 'International', statistic.months, '#BFDDF9', 'sms', 'usage')) // #BEDD77
          datasets.push(this.getDataSetByDestType('SMS Blocked', 'Blocked', statistic.months, '#EFEFFF', 'sms', 'usage'))
        }
        return datasets
      } else {
        datasets.push(this.getDataSetByDestType('CHF(Swisscom)', 'Swisscom', statistic.months, '#6F9953', 'chf', 'sum')) // #E0E0E0  '#2BCA5F'  89B06F
        datasets.push(this.getDataSetByDestType('CHF(Domestic)', 'Domestic', statistic.months, '#A3C28D', 'chf', 'sum')) //A5A5A5   '#6FE194'
        datasets.push(this.getDataSetByDestType('CHF(International)', 'International', statistic.months, '#CFE0C5', 'chf', 'sum')) //D0D0D0    '#B0EEC5'
        datasets.push(this.getDataSetByDestType('CHF(Blocked)', 'Blocked', statistic.months, '#EFEFFF', 'chf', 'sum'))
      }
    },
    getColorByState(statusName) {
      switch (statusName) {
        case "FAILURE":
          return '#EE3333'
        case "PROCESSING":
          return '#3333EE'
        case "DELIVERED":
          return '#33BB33'
        case "CONFIRMED":
          return '#33EE33'
        case "BLOCKED":
          return '#BBBBBB'
        case "NO_INFO":
          return '#EEEEEE'
        default:
          return '#000000'
      }
    },

    getDataSetByDestType(label, destType, months, color, axis, col) {
      return {
        "type": (this.isVersionHourly() ? "line" : "bar"),
        "borderColor": color,
        "pointRadius": 2,
        "label": label,
        "stack": axis,
        "backgroundColor": color,
        "yAxisID": axis,
        "data": _.transform(months, function (result_month, month) {
          result_month.push(_.get(_.find(month.details, ['destType', destType]), col, 0))
        }, [])
      }
    }
    ,

    getChartOptions(chf_or_sms) {
      let options = {
        plugins: {
          title: {
            display: true,
          }
        },
        tooltips: {
          mode: 'x',
          intersect: false
        },
        responsive: true,
        aspectRatio: 4,
        maintainAspectRatio: true,
      }

      if (!chf_or_sms) {
        options.scales = {
          x: {
            stacked: true,
            //barPercentage: 0.3,
            title: {display: true, text: this.version}
          },
          sms: {
            type: 'linear',
            display: true,
            position: 'left',
            stacked: (this.isVersionHourly() ? false : true),
            title: {
              display: true,
              text: 'SMS sent per destination',
            }
          }
        }
      } else {
        options.scales = {
          x: {
            stacked: true,
            //barPercentage: 0.3,
            title: {display: true, text: this.version}
          },

          chf: {
            type: 'linear',
            display: true,
            position: 'left',
            stacked: true,
            title: {
              display: true,
              text: 'CHF sum per destination'
            }
          }
        }
      }

      return options
    }
    ,
  }
  ,
  watch: {
    stats: function () {
      this.calculateChartData()
    }
  }
}

</script>

<style scoped>
.chart-is-loading {
  margin-top: 30px;
  margin-bottom: 30px;
}

.sms-statistic-chart {
  padding-top: 30px;
}
</style>
